import {
	GeneralDocument,
	generalDocumentQuery,
	type ResolvedDoc,
} from '#app/components/general-document.tsx'
import { safeFetch } from '#app/utils/sanity.server.ts'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Help Wanted | Steel City Backgammon' },
]

export async function loader() {
	const doc = await safeFetch<ResolvedDoc | null>(
		`*[_type == "generalDocument" && name == "help-wanted"][0]${generalDocumentQuery}`,
	)
	return { doc }
}

export default function HelpWantedPage({ loaderData }: Route.ComponentProps) {
	return (
		<main className="font-poppins w-[calc(100%-12px)] place-items-center px-4">
			<h1 className="text-center text-4xl">Help Wanted</h1>
			<GeneralDocument doc={loaderData.doc} className="mt-8" />
		</main>
	)
}
